export const FETCH_PLANIFICATION_REQUEST = "FETCH_PLANIFICATION_REQUEST";
export const FETCH_PLANIFICATION_SUCCESS = "FETCH_PLANIFICATION_SUCCESS";
export const FETCH_PLANIFICATION_FAILURE = "FETCH_PLANIFICATION_FAILURE";
